<template>
    <div class="w-full flex flex-column gap-3">
        <div class="flex grid align-items-left overflow-hidden justify-content-start md:px-2">
            <div v-for="card of cards" @click="showCard(card.id)" :key="card.id" 
                class="col-6 xl:col-4 lg:col-4 md:col-6 flex flex-column gap-1 mb-3">
                <div class="w-full flex">
                    <div class="w-full relative cursor-pointer 
                        border-round-lg xl:border-round-2xl lg:border-round-2xl md:border-round-xl" 
                        style="padding-bottom:65%;" 
                        :style="{ background: card.background }">
                        <div class="absolute bottom-0 right-0 pb-2 pr-2">
                            <span class="text-xs font-medium uppercase" :style="{ color: card.color }">{{ card.brand }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="card" class="flex flex-1 flex-column gap-2 text-left px-1 mt-3">
                    <span v-if="card.title" class="text-sm font-medium">{{ card.title }}</span>
                    <span v-if="card.price_issue" class="text-sm font-medium">{{ card.price_issue }}$</span>
                    <span v-if="card[lang].short_description" class="flex text-500 text-xs font-medium">
                        {{ card[lang].short_description }}
                    </span>
                </div>
            </div>
        </div>
    </div>

    <!--Popup card-->
    <Dialog class="w-full surface-0 border-none" modal 
        v-model:visible="displayPopup" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content[lang].detailTitle }}</span>
        </template>

        <div v-if="currentCard" class="w-full flex p-0 mb-5 align-items-center justify-content-center">
            <div class="w-full flex flex-column flex-1 align-items-start border-none border-green-300
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-2xl max-w-20rem"
                :style="{ background: currentCard.background }">
                <div class="w-full flex flex-column flex-1 gap-3 relative">
                    <div class="w-full" style="padding-bottom:60%"></div>
                    <div class="absolute bottom-0 right-0 flex flex-column flex-1 align-items-end border-round-lg">
                        <span class="flex text-md font-medium uppercase" :style="{ color: currentCard.color }">
                            {{ currentCard.brand }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="w-full flex flex-column gap-2 text-left px-0 gap-5 mb-3">
            <div class="w-full flex text-xl font-medium justify-content-center">
                <span class="text-center">{{ currentCard.title }}</span>
            </div>
            <div class="w-full flex justify-content-center line-height-2">
                <span class="text-center">{{ currentCard[lang].description }}</span>
            </div>
            <Message v-if="currentCard[lang].allowed" severity="success" class="border-round-xl" icon="pi pi-thumbs-up">
                <span class="line-height-2 text-sm xl:text-md lg:text-sm">{{ currentCard[lang].allowed }}</span>
            </Message>
            <Message v-if="currentCard[lang].not_allowed" severity="error" class="border-round-xl" icon="pi pi-thumbs-down">
                <span class="line-height-2 text-sm xl:text-md lg:text-sm">{{ currentCard[lang].not_allowed }}</span>
            </Message>
            <Accordion :value="'details'" expandIcon="pi pi-angle-down" collapseIcon="pi pi-angle-up"
                class="w-full h-full border-round-2xl overflow-hidden">
                <AccordionPanel v-if="currentCard[lang].details" :value="'details'">
                    <AccordionHeader>
                        {{ content[lang].detailTitle }}
                    </AccordionHeader>
                    <AccordionContent class="p-0 m-0">
                        <div v-for="detail in currentCard[lang].details" :key="detail.label" class="w-full flex flex-row gap-2 text-sm mb-2 text-900">
                            <span class="flex flex-1">{{ detail.label }}: </span>
                            <span class="flex">{{ detail.value }}</span>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
                <AccordionPanel v-if="currentCard[lang].comissions" :value="'comissions'">
                    <AccordionHeader>
                        {{ content[lang].comsTitle }}
                    </AccordionHeader>
                    <AccordionContent class="p-0 m-0">
                        <div v-for="detail in currentCard[lang].comissions" :key="detail.label" class="w-full flex flex-row gap-2 text-sm mb-2 text-900">
                            <span class="flex flex-1">{{ detail.label }}: </span>
                            <span class="flex">{{ detail.value }}</span>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
                <AccordionPanel v-if="currentCard.blocked_services" :value="'blocked_services'">
                    <AccordionHeader>
                        {{ content[lang].blockedServicesTitle }}
                    </AccordionHeader>
                    <AccordionContent class="p-0 m-0">
                        <div v-for="service in currentCard.blocked_services" :key="service" class="w-full flex flex-row gap-2 text-sm line-height-3 text-900">
                            <span class="inline">{{ service }}</span>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
                <AccordionPanel v-if="currentCard.blocked_regions" :value="'blocked_regions'">
                    <AccordionHeader>
                        {{ content[lang].blockedRegionsTitle }}
                    </AccordionHeader>
                    <AccordionContent class="p-0 m-0">
                        <div v-for="region in currentCard.blocked_regions" :key="region" class="w-full flex flex-row gap-2 text-sm line-height-3 text-900">
                            <span class="inline">{{ region }}</span>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
                <AccordionPanel v-if="currentCard.blocked_mcc" :value="'blocked_mcc'">
                    <AccordionHeader>
                        {{ content[lang].blockedMccTitle }}
                    </AccordionHeader>
                    <AccordionContent class="p-0 m-0">
                        <div v-for="mcc in currentCard.blocked_mcc" :key="mcc" class="w-full flex flex-row gap-2 text-sm line-height-3 text-900">
                            <span class="inline">{{ mcc }}</span>
                        </div>
                    </AccordionContent>
                </AccordionPanel>
            </Accordion>
        </div>

        <template #footer>
            <div class="w-full mt-2 gap-2 flex flex-column">
                <Message v-if="isPhonePrefixRestricted" severity="warn" icon="pi pi-phone" class="border-round-xl mt-2">
                    <span class="text-left text-xs xl:text-md lg:text-sm">
                        {{ content[lang].phonePrefixRestricted }}
                    </span>
                </Message>
                <div v-if="isPhonePrefixRestricted" class="w-full border-0 surface-50 border-round-xl overflow-hidden">
                    <PhoneNumber />
                </div>
                <Message v-if="!canIssue(currentCard)" severity="warn" icon="pi pi-wallet" class="border-round-xl mt-2">
                    <span class="text-left text-xs xl:text-md lg:text-sm">
                        {{ content[lang].notEnoughBalance }}
                    </span>
                </Message>
                <Button @click="create()" :label="getBtnTitle(currentCard)" :loading="loading" 
                    :disabled="!currentCard || loading || !canIssue(currentCard) || !currentCard.active || isPhonePrefixRestricted" 
                    class="p-button-lg w-full border-round-2xl"/>
            </div>
        </template>
    </Dialog>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import CardsTemplate from   '@/assets/json/vcards.json'
import PhoneNumber from      '@/components/personal/profile/Phone.vue'
import { mapActions } from  'vuex'

export default {
    components: {
        PhoneNumber,
    },
    props: {
        balance: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            content: {
                ru: { 
                    empty: 'Нет карт',
                    trans: 'карт',
                    detailTitle: 'Детали карты',
                    comsTitle: 'Стоимость и комиссии',
                    blockedServicesTitle: 'Заблокированные сервисы',
                    blockedRegionsTitle: 'Заблокированные регионы',
                    blockedMccTitle: 'Заблокированные категории MCC',
                    issueBtn: 'Выпустить карту',
                    issueBtnFor: 'Выпустить карту за',
                    error: 'Ошибка',
                    success: 'Успех',
                    successCreate: 'Карта успешно создана',
                    errorCreate: 'Ошибка при создании карты',
                    noaccess: 'У вас нет доступа к этой карте',
                    notEnoughBalance: 'Недостаточно средств для выпуска карты. Пополните баланс Карточного счета',
                    phonePrefixRestricted: 'Для выпуска карты укажите номер телефона с префиксом, отличным от +7. Можете указать любой номер и префикс для выпуска карты и затем изменить его обратно.',
                },
                en: { 
                    empty: 'No card',
                    trans: 'cards',
                    detailTitle: 'Card Detail',
                    comsTitle: 'Cost and commissions',
                    blockedServicesTitle: 'Blocked services',
                    blockedRegionsTitle: 'Blocked regions',
                    blockedMccTitle: 'Blocked MCC categories',
                    issueBtn: 'Issue Card',
                    issueBtnFor: 'Issue Card for',
                    error: 'Error',
                    success: 'Success',
                    successCreate: 'Card created successfully',
                    errorCreate: 'Error creating card',
                    noaccess: 'You do not have access to this card',
                    notEnoughBalance: 'Not enough funds to issue the card. Please top up your Card Account balance',
                    phonePrefixRestricted: 'To issue a card, please use a phone number prefix different from +7. You can use any number and prefix to issue the card and then change it back.',
                },
            },
            loading: false,
            choosed: false,
            displayPopup: false,
            currentCard: null,
            cards: CardsTemplate.filter(card => card.active),
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        phoneNumber() { return this.$store.getters.StateUserPhone },
        phonePrefix() { return this.$store.getters.StateUserPrefix },
        // Нормализуем префикс, чтобы корректно обработать значения вида "+7" и "7".
        isPhonePrefixRestricted() {
            const normalizedPrefix = (this.phonePrefix || '').toString().replace(/\D+/g, '')
            return normalizedPrefix === '7'
        },
    },
    methods: {
        ...mapActions(['ActionGetAllWallets']),
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        getBtnTitle(card){
            if(!card || !card.price_issue) return this.content[this.lang].issueBtn;
            const price = card.price_issue;
            return `${this.content[this.lang].issueBtnFor} ${price}$`;
        },
        canIssue(card){
            if(!card || !card.price_issue) return false;
            const price = card.price_issue;
            if(!this.balance && this.balance !== 0) return false;
            if(this.balance < 0) return false;
            if(this.balance < price) return false;
            return true;
        },
        showCard(id) {
            this.currentCard = this.cards.find(card => card.id === id);
            if (this.currentCard) {
                this.displayPopup = true;
            } else {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Card not found' });
            }
        },
        async create(){
            if(this.isPhonePrefixRestricted) {
                this.showMess('warn', this.content[this.lang].error, this.content[this.lang].phonePrefixRestricted)
                return
            }
            this.loading = true
            if(!this.currentCard) {
                this.showMess('error', this.content[this.lang].error, this.content[this.lang].noaccess)
                this.loading = false
                return
            }
            const data = {
                vendor_id: this.currentCard.code,
                title: this.currentCard.title,
            }
            try{
                const card = await this.connect.CreateCard(data).then(res=>res)
                if(card.result){
                    this.showMess('success', this.content[this.lang].success, this.content[this.lang].successCreate)
                    this.displayPopup = false
                    this.currentCard = null
                    try{ this.ActionGetAllWallets().then(() => {}) } 
                    catch (e) { console.error('Error fetching wallets:', e) }
                }else {
                    if(card.errors) this.showMess('error', this.content[this.lang].error, card.errors[0])
                    else this.showMess('error', this.content[this.lang].error, this.content[this.lang].errorCreate)
                }
                this.loading = false
            } catch (error) {
                this.loading = false
            }
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>